import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-news-predefined-add-modal',
  templateUrl: './news-predefined-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class NewsPredefinedAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  name: string = '';

  private callbackSaved?: () => void;

  constructor(private apiNewsService: ApiNewsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.name = '';
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiNewsService.addNewsPredefined(this.name).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Predefined news added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding predefined news : ' + error);
      }
    );
  }
}
